import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './UpgradeModal.module.css';
import { useGeneration } from '../../contexts/GenerationContext';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = () => {
  const { showUpgradeModal, setShowUpgradeModal, lastGeneratedTool } = useGeneration();
  const navigate = useNavigate();

  if (!showUpgradeModal) return null;

  const handleUpgrade = () => {
    setShowUpgradeModal(false);
    navigate('/pricing');
  };

  return (
    <AnimatePresence>
      {showUpgradeModal && (
        <motion.div
          className={styles.modalOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modalContent}
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <div className={styles.modalHeader}>
              <h2>Upgrade to Premium</h2>
              <button
                className={styles.closeButton}
                onClick={() => setShowUpgradeModal(false)}
              >
                ×
              </button>
            </div>
            <div className={styles.modalBody}>
              <div className={styles.limitIcon}>🔒</div>
              <h3>Generation Limit Reached</h3>
              <p>
                You've used your free generation{' '}
                {lastGeneratedTool && `on ${lastGeneratedTool}`}. Upgrade to our
                Premium plan to enjoy:
              </p>
              <ul className={styles.benefitsList}>
                <li>✨ Unlimited generations across all tools</li>
                <li>🚀 Priority processing</li>
                <li>🎵 Higher quality audio output</li>
                <li>💾 Save and manage your history</li>
                <li>🎨 Access to exclusive features</li>
              </ul>
              <div className={styles.pricingInfo}>
                <span className={styles.price}>$9.99</span>
                <span className={styles.period}>/month</span>
              </div>
            </div>
            <div className={styles.modalFooter}>
              <button
                className={styles.upgradeButton}
                onClick={handleUpgrade}
              >
                Upgrade Now
              </button>
              <button
                className={styles.cancelButton}
                onClick={() => setShowUpgradeModal(false)}
              >
                Maybe Later
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpgradeModal;
